var _defs, _circle, _circle2, _g, _line, _g2, _path, _circle3, _circle4, _g3, _line2, _g4, _path2, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRewardReadingSociety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 998.56 998.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-7);\n      }\n\n      .cls-2 {\n        filter: url(#drop-shadow-8);\n      }\n\n      .cls-3 {\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke: #333;\n      }\n\n      .cls-3, .cls-7 {\n        fill: #333;\n      }\n\n      .cls-4 {\n        fill: #d6d6d6;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 48px;\n      }\n\n      .cls-5 {\n        fill: #d2d8d6;\n      }\n\n      .cls-6 {\n        fill: #75cc81;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 499.28,
    cy: 499.28,
    r: 475.28
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 499.28,
    cy: 499.28,
    r: 289.38
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 375.05,
    cy: 476.48,
    r: 95.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 623.52,
    cy: 476.48,
    r: 95.15
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 470.2,
    y1: 476.48,
    x2: 528.36,
    y2: 476.48
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 375.05,
    y1: 451.35,
    x2: 375.05,
    y2: 499.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 623.52,
    y1: 451.35,
    x2: 623.52,
    y2: 499.28
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M542.41,649v6c0,23.82-19.31,43.13-43.13,43.13h0c-23.82,0-43.13-19.31-43.13-43.13v-6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 499.28,
    cy: 499.28,
    r: 475.28
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 499.28,
    cy: 499.28,
    r: 289.38
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 375.05,
    cy: 476.48,
    r: 95.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 623.52,
    cy: 476.48,
    r: 95.15
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 470.2,
    y1: 476.48,
    x2: 528.36,
    y2: 476.48
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 375.05,
    y1: 451.35,
    x2: 375.05,
    y2: 499.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 623.52,
    y1: 451.35,
    x2: 623.52,
    y2: 499.28
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M542.41,649v6c0,23.82-19.31,43.13-43.13,43.13h0c-23.82,0-43.13-19.31-43.13-43.13v-6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M959.32,304.93c-25.15-59.46-61.14-112.85-106.99-158.7-45.85-45.85-99.24-81.84-158.7-106.99C632.06,13.2,566.67,0,499.28,0s-132.78,13.2-194.35,39.25c-59.46,25.15-112.85,61.14-158.7,106.99-45.85,45.85-81.84,99.24-106.99,158.7C13.2,366.5,0,431.89,0,499.28s13.2,132.78,39.25,194.35c25.15,59.46,61.15,112.85,106.99,158.7,45.85,45.85,99.24,81.84,158.7,106.99,61.57,26.04,126.96,39.25,194.35,39.25s132.78-13.2,194.35-39.25c59.46-25.15,112.85-61.14,158.7-106.99,45.85-45.85,81.84-99.24,106.99-158.7,26.04-61.57,39.25-126.96,39.25-194.35s-13.2-132.78-39.25-194.35ZM915.11,674.93c-22.73,53.74-55.27,102-96.72,143.45-41.45,41.45-89.72,74-143.45,96.72-55.62,23.53-114.72,35.45-175.65,35.45s-120.03-11.93-175.65-35.45c-53.74-22.73-102-55.27-143.45-96.72s-74-89.72-96.72-143.45c-23.53-55.62-35.45-114.72-35.45-175.65s11.93-120.03,35.45-175.65c22.73-53.74,55.27-102,96.72-143.45s89.72-74,143.45-96.72c55.62-23.53,114.72-35.45,175.65-35.45s120.03,11.93,175.65,35.45c53.74,22.73,102,55.27,143.45,96.72,41.45,41.45,74,89.72,96.72,143.45,23.53,55.62,35.45,114.72,35.45,175.65s-11.93,120.03-35.45,175.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M499.28,812.67c83.71,0,162.4-32.6,221.6-91.79,59.19-59.19,91.79-137.89,91.79-221.6s-32.6-162.41-91.79-221.6-137.89-91.79-221.6-91.79-162.41,32.6-221.6,91.79-91.79,137.89-91.79,221.6,32.6,162.41,91.79,221.6c59.19,59.19,137.89,91.79,221.6,91.79ZM311.63,311.63c50.12-50.12,116.77-77.73,187.65-77.73s137.53,27.6,187.65,77.73c50.12,50.12,77.73,116.77,77.73,187.65s-27.6,137.53-77.73,187.65-116.77,77.73-187.65,77.73-137.53-27.6-187.65-77.73c-50.12-50.12-77.73-116.77-77.73-187.65s27.6-137.53,77.73-187.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M491.77,500.48h15.02c11.14,54.24,59.24,95.15,116.72,95.15,65.7,0,119.15-53.45,119.15-119.15s-53.45-119.15-119.15-119.15c-57.48,0-105.59,40.92-116.72,95.15h-15.02c-11.14-54.24-59.24-95.15-116.72-95.15-65.7,0-119.15,53.45-119.15,119.15s53.45,119.15,119.15,119.15c57.48,0,105.59-40.92,116.72-95.15ZM623.52,405.33c39.23,0,71.15,31.92,71.15,71.15s-31.92,71.15-71.15,71.15-71.15-31.92-71.15-71.15,31.92-71.15,71.15-71.15ZM303.89,476.48c0-39.23,31.92-71.15,71.15-71.15s71.15,31.92,71.15,71.15-31.92,71.15-71.15,71.15-71.15-31.92-71.15-71.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M399.05,499.28v-47.93c0-13.25-10.75-24-24-24s-24,10.75-24,24v47.93c0,13.25,10.75,24,24,24s24-10.75,24-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M623.52,523.28c13.25,0,24-10.75,24-24v-47.93c0-13.25-10.75-24-24-24s-24,10.75-24,24v47.93c0,13.25,10.75,24,24,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M542.41,625c-13.25,0-24,10.75-24,24v6c0,10.55-8.58,19.13-19.13,19.13s-19.13-8.58-19.13-19.13v-6c0-13.25-10.75-24-24-24s-24,10.75-24,24v6c0,37.01,30.11,67.13,67.13,67.13s67.13-30.11,67.13-67.13v-6c0-13.25-10.75-24-24-24Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.84,705.07c-3.09-5.46-4.5-10.95-4.21-16.48.29-5.53,2.04-10.69,5.26-15.48,3.22-4.79,7.7-8.81,13.45-12.07,5.75-3.25,11.37-4.97,16.87-5.16,5.5-.18,10.57,1.09,15.21,3.83,4.64,2.74,8.52,6.86,11.64,12.37,2.54,4.49,3.94,9.01,4.19,13.56.25,4.55-.57,8.81-2.44,12.77-1.88,3.96-4.74,7.31-8.57,10.03l-9.01-15.91c1.59-1.28,2.8-2.67,3.63-4.18.84-1.51,1.24-3.09,1.22-4.75-.03-1.66-.53-3.36-1.53-5.11-1.08-1.91-2.54-3.32-4.37-4.25-1.84-.93-4.19-1.14-7.06-.63-2.87.5-6.38,1.93-10.54,4.29-6.29,3.57-10.24,7.03-11.84,10.38-1.6,3.36-1.59,6.47.04,9.34.99,1.75,2.29,3.01,3.9,3.77,1.61.76,3.37,1.12,5.29,1.07,1.92-.05,3.84-.43,5.75-1.13l9.01,15.91c-3.15,1.26-6.3,2.18-9.47,2.75-3.16.57-6.28.52-9.36-.13-3.08-.65-6.05-2.15-8.91-4.5-2.86-2.35-5.58-5.78-8.13-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.67,737.06l65-23.36,11.34,13.87-35.82,59.06-10.94-13.39,7.03-11.33-12.99-15.9-12.55,4.56-11.06-13.53ZM192.19,739.42l8.15,9.97,12.06-18.12-20.21,8.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.68,799.51l33.54-36.69-13.63-12.46,10.39-11.37,40.35,36.88-10.39,11.37-13.76-12.58-33.54,36.69-12.96-11.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M247.36,832.07l36.02-54.24,40.06,26.6-8.1,12.03-25.28-16.79-5.98,9,21.15,14.05-7.82,11.78-21.27-14.12-6.13,9.23,25.54,16.96-8.07,12.15-40.13-26.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M302.63,866.78l27.54-59,26.76,12.5c5.11,2.39,8.83,5.15,11.16,8.29,2.33,3.14,3.53,6.48,3.6,10,.07,3.53-.72,7.08-2.38,10.64-1.41,3.02-3.01,5.41-4.81,7.17-1.8,1.76-3.75,3.07-5.86,3.92-2.11.86-4.33,1.42-6.67,1.68l-.3,27.69-16.28-7.6.92-24.32-8.32-3.89-9.49,20.32-15.87-7.41ZM333.51,842.04l9.1,4.25c2.04.95,4.11.94,6.2-.04,2.1-.98,3.59-2.42,4.48-4.32.95-2.04,1.03-4.13.24-6.27-.79-2.14-2.08-3.63-3.88-4.47l-9.1-4.25-7.05,15.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M366.99,894.44l16.9-62.88,24.87,6.68c4.64,1.25,8.6,3.2,11.88,5.85,3.28,2.65,5.58,5.86,6.9,9.62,1.32,3.76,1.37,7.91.15,12.46-1.11,4.15-2.98,7.46-5.61,9.94-2.62,2.48-5.83,4.07-9.62,4.76-3.79.69-7.99.42-12.6-.82l-10.13-2.72-5.82,21.66-16.92-4.55ZM392.94,864.68l9.78,2.63c2.15.58,4.16.2,6.04-1.13,1.88-1.33,3.09-3.01,3.64-5.04.58-2.17.31-4.25-.82-6.21-1.13-1.97-2.64-3.2-4.53-3.71l-9.78-2.63-4.32,16.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.02,909.4l9.28-64.44,17.34,2.5-9.28,64.44-17.34-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M463.76,913.96l2.2-65.07,17.51.59-1.72,50.67,26.01.88-.49,14.4-43.52-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M521.29,914.68l-6.79-64.75,17.42-1.83,5.29,50.42,25.88-2.71,1.5,14.33-43.3,4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M576.14,908.67l5.2-68.87,17.3-4.69,39.3,56.8-16.69,4.53-7.47-11.04-19.82,5.38-.96,13.32-16.86,4.57ZM593.61,875.38l12.43-3.37-11.62-18.4-.81,21.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M651.26,886.48l-27.56-58.99,26.76-12.5c5.11-2.39,9.62-3.47,13.52-3.24,3.9.23,7.23,1.45,9.98,3.66,2.75,2.21,4.96,5.09,6.63,8.66,1.41,3.02,2.21,5.78,2.41,8.29.19,2.51-.06,4.85-.75,7.01-.7,2.16-1.69,4.23-2.99,6.2l21.04,18-16.28,7.61-18.06-16.31-8.32,3.89,9.49,20.31-15.87,7.42ZM652.11,846.92l9.1-4.25c2.04-.95,3.36-2.55,3.95-4.78.6-2.23.45-4.3-.44-6.21-.95-2.04-2.5-3.44-4.65-4.21-2.15-.77-4.12-.73-5.92.1l-9.1,4.25,7.05,15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M756.12,826.64c-4.95,3.85-10.19,6.03-15.69,6.55-5.51.52-10.87-.47-16.07-2.96-5.21-2.49-9.84-6.35-13.89-11.56-4.05-5.21-6.57-10.53-7.54-15.95-.98-5.42-.45-10.62,1.59-15.6,2.04-4.98,5.56-9.42,10.56-13.31,4.08-3.17,8.35-5.2,12.82-6.11,4.47-.9,8.8-.71,12.99.57,4.19,1.29,7.91,3.63,11.17,7.03l-14.44,11.22c-1.49-1.39-3.05-2.38-4.66-2.99-1.61-.61-3.24-.78-4.88-.52-1.64.27-3.25,1.01-4.84,2.25-1.73,1.34-2.92,2.99-3.57,4.94-.65,1.95-.52,4.31.4,7.08.91,2.77,2.84,6.04,5.76,9.81,4.44,5.71,8.43,9.12,11.99,10.22,3.55,1.1,6.63.63,9.24-1.39,1.59-1.23,2.64-2.7,3.17-4.4s.62-3.49.29-5.39c-.33-1.89-.98-3.73-1.95-5.52l14.44-11.22c1.71,2.93,3.07,5.92,4.09,8.97,1.02,3.05,1.43,6.14,1.23,9.28-.2,3.14-1.26,6.3-3.16,9.47-1.91,3.17-4.91,6.35-9.01,9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M789.4,797.04l-47.57-44.46,11.96-12.8,37.04,34.62,17.77-19.01,10.53,9.84-29.73,31.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M843.98,732.6c-3.93,5.78-8.02,9.71-12.26,11.78s-8.58,2.66-13.03,1.78c-4.45-.88-8.95-2.88-13.52-5.98l-31.57-21.48,9.98-14.67,32.16,21.88c3.72,2.53,6.95,3.47,9.69,2.81,2.74-.66,4.87-2.12,6.41-4.38,1.01-1.49,1.62-3.12,1.83-4.88.2-1.77-.17-3.56-1.12-5.39-.95-1.83-2.67-3.59-5.15-5.28l-32.16-21.88,9.98-14.67,31.57,21.48c4.57,3.11,8.08,6.57,10.53,10.38,2.45,3.81,3.5,8.07,3.13,12.77-.37,4.7-2.52,9.95-6.46,15.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M867.47,692.61l-59-27.54,11.01-23.58c3.85-8.24,7.99-13.62,12.43-16.14,4.44-2.52,9.17-2.6,14.2-.25,2.72,1.27,4.81,3.07,6.27,5.41,1.46,2.34,2.24,5.75,2.33,10.23,1.97-2.23,3.88-3.81,5.74-4.75,1.86-.94,3.62-1.43,5.27-1.49s3.18.13,4.59.55c1.41.43,2.67.9,3.78,1.42,5.49,2.56,8.7,6.27,9.62,11.12s-.63,11.56-4.63,20.13l-11.62,24.89ZM838.9,659.94l4.67-10c.44-.95.71-1.86.78-2.74.08-.87,0-1.69-.23-2.44-.23-.75-.61-1.43-1.14-2.02-.53-.6-1.18-1.07-1.94-1.43-1.77-.83-3.46-.83-5.09-.01-1.62.82-2.87,2.16-3.75,4.04l-4.4,9.42,11.1,5.18ZM862.97,671.17l4.48-9.59c1.09-2.34,1.28-4.39.56-6.15-.72-1.76-1.85-3-3.4-3.73-1.09-.51-2.19-.69-3.3-.55-1.11.14-2.15.6-3.12,1.35-.97.76-1.76,1.8-2.38,3.14l-4.67,10,11.83,5.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRewardReadingSociety);
export default __webpack_public_path__ + "static/media/icon-reward-reading-society.3d63298ef9ea97f2efc16282ac38bb87.svg";
export { ForwardRef as ReactComponent };